module.exports = __webpack_public_path__ + "img/melia-room.628e36e8.jpg";